import { NgModule } from '@angular/core';

import { LoginApiService } from './api/login-api.service';
import { SourceMaintenanceApiService } from './api/source-maintenance-api.service';
import { ReasonCodeMaintenanceApiService } from './api/reason-code-maintenance-api.service';
import { UserMaintenanceService } from './api/user-maintenance.service';
import { SpanMaintenanceApiService } from './api/span-maintenance-api.service';
import { TprecmApiService } from './api/tprecm-api.service';
import { ViewUpdateTprApiService } from './api/view-update-tpr-api.service';
import { FileDownloadApiService } from './api/file-download-api.service';

export { LoginApiService } from './api/login-api.service';
export { SourceMaintenanceApiService } from './api/source-maintenance-api.service';
export { ReasonCodeMaintenanceApiService } from './api/reason-code-maintenance-api.service';
export { UserMaintenanceService } from './api/user-maintenance.service';
export { SpanMaintenanceApiService } from './api/span-maintenance-api.service';
export { TprecmApiService } from './api/tprecm-api.service';
export { ViewUpdateTprApiService } from './api/view-update-tpr-api.service';
export { FileDownloadApiService } from './api/file-download-api.service';

@NgModule({
   providers: [
      LoginApiService,
      SourceMaintenanceApiService,
      ReasonCodeMaintenanceApiService,
      UserMaintenanceService,
      SpanMaintenanceApiService,
      TprecmApiService,
      ViewUpdateTprApiService,
      FileDownloadApiService
   ]
})
export class ApiModule { }